/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
	Filter,
	FilterFromJSON,
	FilterToJSON,
	RequestResponse,
	RequestResponseFromJSON,
	RequestResponseToJSON,
	StudentCVAccessDTOPagedResponse,
	StudentCVAccessDTOPagedResponseFromJSON,
	StudentCVAccessDTOPagedResponseToJSON,
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumToJSON,
} from "../models";

export interface ApiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGetRequest {
	companyId: string;
}

export interface ApiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGetRequest {
	companyId: string;
	namePattern?: string;
	faculties?: Array<string>;
	years?: Array<StudentYearEnum>;
	page?: number;
	pageSize?: number;
}

export interface ApiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGetRequest {
	companyId: string;
	language?: string;
}

export interface ApiPoliJobsMarketShareCVAccessCompanyIdPostRequest {
	companyId: string;
}

/**
 *
 */
export class PoliJobsMarketApi extends runtime.BaseAPI {
	/**
	 */
	async apiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGetRaw(
		requestParameters: ApiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<Blob>> {
		if (
			requestParameters.companyId === null ||
			requestParameters.companyId === undefined
		) {
			throw new runtime.RequiredError(
				"companyId",
				"Required parameter requestParameters.companyId was null or undefined when calling apiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGet."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/PoliJobsMarket/GenerateStudentAccessQRCodePdf/{companyId}`.replace(
					`{${"companyId"}}`,
					encodeURIComponent(String(requestParameters.companyId))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.BlobApiResponse(response);
	}

	/**
	 */
	async apiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGet(
		requestParameters: ApiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<Blob> {
		const response =
			await this.apiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGetRaw(
				requestParameters,
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiPoliJobsMarketGenerateStudentAccessQRCodePngGetRaw(
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<Blob>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/PoliJobsMarket/GenerateStudentAccessQRCodePng`,
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.BlobApiResponse(response);
	}

	/**
	 */
	async apiPoliJobsMarketGenerateStudentAccessQRCodePngGet(
		initOverrides?: RequestInit
	): Promise<Blob> {
		const response =
			await this.apiPoliJobsMarketGenerateStudentAccessQRCodePngGetRaw(
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGetRaw(
		requestParameters: ApiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<StudentCVAccessDTOPagedResponse>> {
		if (
			requestParameters.companyId === null ||
			requestParameters.companyId === undefined
		) {
			throw new runtime.RequiredError(
				"companyId",
				"Required parameter requestParameters.companyId was null or undefined when calling apiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGet."
			);
		}

		const queryParameters: any = {};

		if (requestParameters.namePattern !== undefined) {
			queryParameters["NamePattern"] = requestParameters.namePattern;
		}

		if (requestParameters.faculties) {
			queryParameters["Faculties"] = requestParameters.faculties;
		}

		if (requestParameters.years) {
			queryParameters["Years"] = requestParameters.years;
		}

		if (requestParameters.page !== undefined) {
			queryParameters["Page"] = requestParameters.page;
		}

		if (requestParameters.pageSize !== undefined) {
			queryParameters["PageSize"] = requestParameters.pageSize;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/PoliJobsMarket/GetAllStudentCVsForCompany/{companyId}`.replace(
					`{${"companyId"}}`,
					encodeURIComponent(String(requestParameters.companyId))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			StudentCVAccessDTOPagedResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGet(
		requestParameters: ApiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<StudentCVAccessDTOPagedResponse> {
		const response =
			await this.apiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGetRaw(
				requestParameters,
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGetRaw(
		requestParameters: ApiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<Array<Filter>>> {
		if (
			requestParameters.companyId === null ||
			requestParameters.companyId === undefined
		) {
			throw new runtime.RequiredError(
				"companyId",
				"Required parameter requestParameters.companyId was null or undefined when calling apiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGet."
			);
		}

		const queryParameters: any = {};

		if (requestParameters.language !== undefined) {
			queryParameters["language"] = requestParameters.language;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/PoliJobsMarket/GetStudentCvAccessFilters/{companyId}`.replace(
					`{${"companyId"}}`,
					encodeURIComponent(String(requestParameters.companyId))
				),
				method: "GET",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			jsonValue.map(FilterFromJSON)
		);
	}

	/**
	 */
	async apiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGet(
		requestParameters: ApiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGetRequest,
		initOverrides?: RequestInit
	): Promise<Array<Filter>> {
		const response =
			await this.apiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGetRaw(
				requestParameters,
				initOverrides
			);
		return await response.value();
	}

	/**
	 */
	async apiPoliJobsMarketShareCVAccessCompanyIdPostRaw(
		requestParameters: ApiPoliJobsMarketShareCVAccessCompanyIdPostRequest,
		initOverrides?: RequestInit
	): Promise<runtime.ApiResponse<RequestResponse>> {
		if (
			requestParameters.companyId === null ||
			requestParameters.companyId === undefined
		) {
			throw new runtime.RequiredError(
				"companyId",
				"Required parameter requestParameters.companyId was null or undefined when calling apiPoliJobsMarketShareCVAccessCompanyIdPost."
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.apiKey) {
			headerParameters["Authorization"] =
				this.configuration.apiKey("Authorization"); // Bearer authentication
		}

		const response = await this.request(
			{
				path: `/api/PoliJobsMarket/ShareCVAccess/{companyId}`.replace(
					`{${"companyId"}}`,
					encodeURIComponent(String(requestParameters.companyId))
				),
				method: "POST",
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			RequestResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiPoliJobsMarketShareCVAccessCompanyIdPost(
		requestParameters: ApiPoliJobsMarketShareCVAccessCompanyIdPostRequest,
		initOverrides?: RequestInit
	): Promise<RequestResponse> {
		const response = await this.apiPoliJobsMarketShareCVAccessCompanyIdPostRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}
}
